import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../config/firebase';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'axios';

const Movie = ({
                   title,
                   year,
                   image,
                   rating,
                   id,
                   type = "movie",
                   isFavorite: propIsFavorite,
                   isPartnerFavorite: propIsPartnerFavorite,
                   currentUserId,
                   partnerUserId,
                   savedBy
               }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [isFavorite, setIsFavorite] = useState(propIsFavorite || false);
    // Track partner favorite state separately
    const [isPartnerFavorite, setIsPartnerFavorite] = useState(propIsPartnerFavorite || false);
    const imageUrl = "https://image.tmdb.org/t/p/w500" + image;

    // Use onAuthStateChanged to reliably get current user
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });
        return () => unsubscribe();
    }, []);




    // Update both states when props change
    useEffect(() => {
        setIsFavorite(propIsFavorite === true);
        setIsPartnerFavorite(propIsPartnerFavorite === true);
    }, [propIsFavorite, propIsPartnerFavorite]);


    useEffect(() => {
        if (user?.uid && id) {
            checkIfFavorite();

            if (partnerUserId) {
                checkIfPartnerFavorite();
            }
        }
    }, [user, id, partnerUserId, type]); // Added type to dependencies

    const checkIfFavorite = async () => {
        if (!user?.uid) return;

        try {
            const response = await axios.get(`https://api.frazza.online/favorites/check/${user.uid}/${type}/${id}`);
            setIsFavorite(response.data.isFavorite);
        } catch (error) {
            console.error("Error checking favorite status:", error);
        }
    };

    const checkIfPartnerFavorite = async () => {
        if (!partnerUserId) return;

        try {
            const response = await axios.get(`https://api.frazza.online/favorites/check/${partnerUserId}/${type}/${id}`);
            setIsPartnerFavorite(response.data.isFavorite);
        } catch (error) {
            console.error("Error checking partner favorite:", error);
        }
    };

    const handleMovieClick = () => {
        navigate(`/dashboard/content/movie/${id}`);
    };

    const toggleFavorite = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!user?.uid) {
            alert('Please sign in to save favorites');
            return;
        }

        try {
            // Determine which user's favorite to toggle
            let targetUserId = user.uid;
            let forceRemove = false;

            if (!isFavorite && isPartnerFavorite && partnerUserId) {
                targetUserId = partnerUserId;
                forceRemove = true;
            }

            // Get user name for savedBy field
            let userName = user.displayName || user.email?.split('@')[0] || 'Unknown User';
            try {
                const userResponse = await axios.get(`https://api.frazza.online/user/${user.uid}`);
                if (userResponse.data.success) {
                    userName = userResponse.data.data.firstName || userResponse.data.data.name || userName;
                }
            } catch (error) {
                console.error('Error fetching user info:', error);
            }

            // Prepare favorite item data
            const itemData = {
                id,
                title,
                year,
                image,
                rating,
                type,
                savedBy: userName
            };

            // Update favorites via API
            const response = await axios.post('https://api.frazza.online/favorites/toggle', {
                userId: targetUserId,
                itemData,
                forceRemove
            });

            // Update local state based on which user's favorites were modified
            if (targetUserId === user.uid) {
                setIsFavorite(!isFavorite);
            } else {
                setIsPartnerFavorite(false); // Reset partner favorite if we removed it
            }

        } catch (error) {
            console.error('Error updating favorite:', error);
        }
    };

    const renderSavedByIndicator = () => {
        if (!savedBy) return null;
        return (
            <span className="saved-by-badge">Saved by: {savedBy}</span>
        );
    };

    const renderRating = () => {
        if (rating === undefined || rating === null || rating === '') return null;
        const maxDots = 5;
        const numeric = typeof rating === 'number' ? rating : parseFloat(rating) || 0;
        const clamped = Math.max(0, Math.min(numeric, maxDots));
        const filled = Math.round(clamped);
        const dots = Array.from({ length: maxDots }, (_, i) => (
            <span key={i} className={`rating-dot ${i < filled ? 'filled' : ''}`}></span>
        ));
        return (
            <div className="rating-display">
                {dots}
                <span className="rating-number">{numeric.toFixed(1)}</span>
            </div>
        );
    };

    return (
        <div className="movie-card" onClick={handleMovieClick}>
            <div className="movie-image">
                <img src={imageUrl} alt={title} />
                {renderSavedByIndicator()}
                <button className="favorite-btn" onClick={toggleFavorite} aria-label="Toggle favorite">
                    {(isFavorite || isPartnerFavorite) ? (
                        <AiFillHeart className="heart-icon filled" />
                    ) : (
                        <AiOutlineHeart className="heart-icon" />
                    )}
                </button>
            </div>
            <div className="movie-info">
                <h3 className="movie-title">{title}</h3>
                <div className="movie-meta">
                    {year && <span className="year-badge">{year}</span>}
                    {renderRating()}
                </div>
            </div>
        </div>
    );
};

export default Movie;
